import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import heroStyles from './hero.module.scss'

export default function Hero() {
    const { t, i18n } = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            setIsTablet(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section className={heroStyles.section_hero}>
            <div className={`${heroStyles.hero_container} ${i18n.language === 'ar' ? heroStyles.hero_container_ar : ''}`}>
                <div className={heroStyles.text_block}>
                    <div className={heroStyles.hero_text_box}>
                        {i18n.language === 'en' ?
                            <>
                                <h1 className={heroStyles.heading_primary}>
                                    Arab Technical Company Ltd.
                                </h1>
                                <h2 className={heroStyles.heading_secondary}>
                                    ENGINEERING, CONSTRUCTION, <span>FIELD SERVICES, and O&M.</span>
                                </h2>
                                <p className={heroStyles.hero_brief}>
                                    <b>ArabTech</b> was incorporated in 2004 with the purpose of providing support systems and services for Substations and Industrial sectors in Western Province of KSA.
                                </p>
                            </>
                            :
                            <>
                                <h1 className={heroStyles.heading_primary}>
                                    شـركـة عـرب التـقـنـيـة المـحـدودة
                                </h1>
                                <h2 className={heroStyles.heading_secondary}>
                                    الهندسة والبناء والخدمات الميدانية
                                    <span>
                                        والتشغيل والصيانة
                                    </span>
                                </h2>
                                <p className={heroStyles.hero_brief}>
                                    تأسست شركة
                                    <b> عرب تك </b>
                                    في عام 2004 بهدف توفير أنظمة الدعم والخدمات لمحطات الكهرباء والقطاعات الصناعية في المنطقة الغربية من المملكة العربية السعودية.
                                </p>
                            </>
                        }
                    </div>
                </div>

                {!isMobile && (
                    <div className={heroStyles.image_block}>
                        <div className={heroStyles.composition}>
                            <img
                                alt="Engineering work"
                                className={`${heroStyles.composition__photo} ${heroStyles.composition__photo_p1}`}
                                src="../images/hero/hero_pic_1.jpeg" />

                            <img
                                alt="Construction site"
                                className={`${heroStyles.composition__photo} ${heroStyles.composition__photo_p2}`}
                                src="../images/hero/hero_pic_2.jpeg" />

                            <img
                                alt="Field services"
                                className={`${heroStyles.composition__photo} ${heroStyles.composition__photo_p3}`}
                                src="../images/hero/hero_pic_3.jpeg" />

                            {!isTablet && (
                                <>
                                    <img
                                        alt="Technical work"
                                        className={`${heroStyles.composition__photo} ${heroStyles.composition__photo_p4}`}
                                        src="../images/hero/hero_pic_4.jpeg" />

                                    <img
                                        alt="Operations and maintenance"
                                        className={`${heroStyles.composition__photo} ${heroStyles.composition__photo_p5}`}
                                        src="../images/hero/hero_pic_6.jpeg" />
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </section>
    )
}